import script from "./footBox.vue?vue&type=script&setup=true&lang=js"
export * from "./footBox.vue?vue&type=script&setup=true&lang=js"

import "./footBox.vue?vue&type=style&index=0&id=304e7e6d&lang=scss&scoped=true"

import exportComponent from "C:\\develop\\workspace_cursor\\weiquyun\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-304e7e6d"]])

export default __exports__